
import React from 'react';
import { StyledFormControl, StyledFormControlLabel, StyledFormLabel, StyledCheckedbox, StyledFormGroup } from '../../styles/matieralui/Form';

export const CheckboxGroup = ({options, onChange, label}) => {

    const handleChange = (e) => {
        const newOptions = options.map(option => {
            if(option.name === e.target.name) option.checked = e.target.checked;
            return option;
        })
        onChange(newOptions)
    }

    return (
        <StyledFormControl>
            <StyledFormLabel>{label}</StyledFormLabel>
            <StyledFormGroup>
                {options && options.map(option => (
                    <StyledFormControlLabel 
                        key={option.key} 
                        label={option.label} 
                        control={
                            <StyledCheckedbox 
                                color="primary"
                                onChange={handleChange} 
                                checked={!!option?.checked} 
                                name={option.name}

                            />
                        } 
                    />
                ))}
            </StyledFormGroup>
        </StyledFormControl>
    )
}